import asyncActionTypes from '../actions/types.js';

const initialState = 0;

const countErrorPayment = (state = initialState, action) => {
  if (action.type === asyncActionTypes.COUNT_ERROR_PAYMENT.FAIL) {
    return state += 1;
  } else {
    return state;
  }
};

export default countErrorPayment;
